import { Tag } from "react-tag-input/types/components/SingleTag";

import { AdminRoles, RiseDomain, ValidationMessages } from "globalConstants";
import { isEmailAllowed, isFeatureEnabled } from "helpers";

// Check if the input domains matches a specific format. The format should be domain.xxx
// The function accepts one argument, which can be an array of strings or a string
export const validateDomains = (
	domains: Tag[] | string,
): string | undefined => {
	if (!domains) return;

	const regex = /^[a-z\d\-.]{1,251}\.[a-z\d-]{1,50}$/i;

	if (Array.isArray(domains) && domains.length > 0) {
		const allMatchRegex = domains.every(item => regex.test(item.text));

		if (!allMatchRegex) {
			return "All items should match the expression, ex. domain.xxx";
		}
	}

	if (typeof domains === "string") {
		const matchRegex = regex.test(domains);

		if (!matchRegex) {
			return "Should match the expression, ex. domain.xxx";
		}
	}
	return undefined;
};

export const normalizeDomains = (value: string): string => {
	if (!value) {
		return value;
	}
	return value.replace(/([^a-z\d\-.])/g, "");
};

export const emailWithDomainsValid = (value, domains) => {
	const isAllowed = isEmailAllowed(value, domains);
	if (!isAllowed) {
		return ValidationMessages.NotAllowedEmail;
	}
};

/**
 * Validates if the email domain is allowed for a specific user type/role
 * For admin roles, the email must be from the Rise domain
 * @param email - The email address to validate
 * @param role - The user role to check against
 * @param preValidationCallback - Optional callback to execute before validation
 * @param errorCallback - Callback that returns the error message if validation fails
 * @returns The error message if validation fails, undefined otherwise
 */
export const validateEmailForUserType = ({
	email,
	role,
	preValidationCallback,
	errorCallback,
}: {
	email: string | undefined;
	role: string | undefined;
	preValidationCallback?: () => void;
	errorCallback?: () => void;
}) => {
	if (
		!email ||
		!role ||
		!isFeatureEnabled("ValidateEmailDomainForAdminUsers")
	)
		return;

	const isRiseAdminRole = Object.values(AdminRoles).includes(role);
	if (!isRiseAdminRole) {
		return;
	}
	preValidationCallback?.();

	if (!isEmailAllowed(email, [RiseDomain])) {
		errorCallback?.();
		return ValidationMessages.NotAllowedEmailForUserType;
	}
};
